<template>
    <li class="device" @click="selectDevice" :class="device == activeDevice ? 'is-active' : ''">
        <div class="device__wrapper">
            <img :src="iconSrc"><br>
            <div class="device__name">
                {{ device.name }}
            </div>
            <template v-if="device.subline">
                <div class="device__subline">
                    {{ device.subline }}
                </div>
            </template>
        </div>
    </li>
</template>

<script>
    export default {
        name: "Device",
        props: ['device', 'activeDevice'],
        computed: {
            iconSrc() {
                return require('../../assets/devices/' + this.device.iconName);
            }
        },
        methods: {
            selectDevice() {
                if (this.device != this.activeDevice) {
                    this.$emit('deviceSelected', this.device);
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .device {
        border: 1px solid transparent;
        cursor: pointer;
        display: inline-block;
        font-family: PxGroteskRegular;
        font-size: 14.56px;
        text-align: center;
        transition: border .4s linear;
        vertical-align: top;
        width: 33.3%;

        @media (min-width: 768px) {
            width: 25%;
        }

        @media (min-width: 1920px) {
            width: 20%;
        }

        &.is-active {
            border: 1px solid #FFFFFF;
            cursor: default;
            position: relative;

            &::before {
                background: transparent url('../../assets/checked.svg');
                content: '';
                height: 7px;
                position: absolute;
                top: 8px;
                right: 9px;
                width: 9px;

            }
        }

        &__name {
            margin: 0 auto;
            max-width: 70%;
        }

        img {
            height: auto;
            max-width: 70%;
        }

    }

    .device__wrapper {
        padding: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/components/panels/Device.vue